<template>
  <!-- 账户管理---角色权限 -->
  <div class="page">
    <Headertip :tipContent="tipContent"></Headertip>
    <role-Item></role-Item>
    <!-- 新增角色成员 -->
    <createRole :addRole="addRole"></createRole>
    <!-- 成员列表 -->
    <member :memberParams="memberParams"></member>
  </div>
</template>

<script>
import roleItem from '@account/components/role/roleItem.vue';
import createRole from '@account/components/role/createRole.vue';
import member from '@account/components/role/member.vue';
export default {
  provide() {
    return {
      add: this.createNewRole,
      edit: this.changeMember,
      change: this.editMember,
      role: this.editRole,
    };
  },
  components: {
    roleItem,
    createRole,
    member,
  },
  data() {
    return {
      tipContent:
        '提交企业审核的成员为超级管理员，超级管理员拥有全部应用的所有权限。管理平台还提供了五种默认角色「普通管理员」「财务」「运营」「技术」「普通成员」，默认角色权限可编辑。',
      // 新增角色成员弹窗
      addRole: {
        dialogFormVisible: false,
      },
      // 成员列表
      memberParams: {
        dialogTableVisible: false,
      },
    };
  },
  methods: {
    // 添加新角色
    createNewRole() {
      this.addRole.dialogFormVisible = true;
    },
    // 管理成员
    changeMember() {
      this.memberParams.dialogTableVisible = true;
    },
    // 修改成员
    editMember() {
      this.$router.push({ name: 'account/role/edit/member' });
    },
    // 编辑角色
    editRole() {
      this.$router.push({ name: 'account/role/edit' });
    },
  },
};
</script>

<style lang="less" scope></style>
